import { render, staticRenderFns } from "./drawerMilestone.vue?vue&type=template&id=070e4c54&"
import script from "./drawerMilestone.vue?vue&type=script&lang=js&"
export * from "./drawerMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports